import { render } from "./EventCardSkeleton.vue?vue&type=template&id=6deec7c6&scoped=true"
const script = {}

import "./EventCardSkeleton.vue?vue&type=style&index=0&id=6deec7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deec7c6"]])

export default __exports__